import React from 'react';
import Img from 'react-image';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import { ImgClick } from '../../utility';

import soundShootingFailed from '../sounds/play-shooting-failed.mp3';
import soundShooting from '../sounds/play-shooting.mp3';
import AnimationWithSound from '../AnimationWithSound';

export const BOSS_LAMP_ARSENAL_STATE = {
  NOT_DISPLAYED: 0,
  DISPLAY: 1,
  FIGHTING: 2,
  SHOOT: 3,
  NOT_SHOOT: 4,
};

const BossLampArsenal = ({ handleOnClick, state, onShootCompleted }) => {
  const { images } = useImagesContext();
  const config = useSelector((state) => state.config);
  const [ownState, setOwnState] = React.useState([state]);

  React.useEffect(() => {
    if (
      state === BOSS_LAMP_ARSENAL_STATE.SHOOT ||
      state === BOSS_LAMP_ARSENAL_STATE.NOT_SHOOT
    ) {
      setOwnState((v) => [...v, state]);
      setTimeout(() => {
        setOwnState([state]);
      }, 1000);
    } else {
      setOwnState([state]);
    }
  }, [state]);

  return (
    <>
      {ownState.includes(BOSS_LAMP_ARSENAL_STATE.DISPLAY) && (
        <FullScreenImage src={images['play-right-gun.png']} />
      )}
      {ownState.includes(BOSS_LAMP_ARSENAL_STATE.FIGHTING) && (
        <>
          <FullScreenImage src={images['play-right-gun.png']} />
          <LampRightButton
            src={images['play-lamp-right.png']}
            onClick={() => {
              console.debug('Lamp Right button clicked');
              handleOnClick();
            }}
          />
        </>
      )}
      {ownState.includes(BOSS_LAMP_ARSENAL_STATE.SHOOT) && (
        <AnimationWithSound
          imageUrl={images['play-boss-shooting.png']}
          soundFile={soundShooting}
          playSound={!config.isMutedSound}
          onSoundEnd={onShootCompleted}
        />
      )}
      {ownState.includes(BOSS_LAMP_ARSENAL_STATE.NOT_SHOOT) && (
        <AnimationWithSound
          imageUrl={images['play-boss-shooting-failed.png']}
          soundFile={soundShootingFailed}
          playSound={!config.isMutedSound}
          onSoundEnd={onShootCompleted}
        />
      )}
    </>
  );
};

const FullScreenImage = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const LampRightButton = styled(ImgClick)`
  position: absolute;
  right: 29px;
  top: 266px;
`;
export default BossLampArsenal;
